export default class UserViewModel {

  constructor(ramblerIdUserData) {
    const { display, profile, info } = ramblerIdUserData;
    // Телефон если есть
    this.phone = (ramblerIdUserData.phones && ramblerIdUserData.phones[0]) || null;
    // Полное имя для отображения
    this.name = display.display_name;
    // Короткое имя для отображения
    this.shortName = display.short_name;
    // Ссылка на аватар
    this.avatar = display.avatar.url;
    // Email пользователя
    this.email = info.email;
    // Пол
    this.gender = profile.gender;
  }

}



// WEBPACK FOOTER //
// ./daily/assets/id/userModel.js